import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Articles from '/components/Brand/Articles';
import BrandVideos from '/components/Brand/BrandVideos';
import Hidden from '@material-ui/core/Hidden';
import { Comments } from 'react-facebook';

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    marginTop: 12,
  },
  tabsRoot:{
    borderBottom: '1px solid #b1b1b1'
  },
  tabsScroller:{
    marginBottom: '-17px!important'
  },
  tabsIndicator: {
    height: 4
  }
});

class AuthorTabs extends React.Component {
  state = {
    value: 0,
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };
  readAllClick = (index) => {
    this.setState({ value: index });
  };

  render() {
    const { classes, asPath, articlesCount, videosCount, mobileMaxNum, articles, func, itemsDesktop, itemsMobile, authorVideos, videoItems, videoNextFunc } = this.props;
    const { value } = this.state;

    return (
      <div className={classes.root}>
          <Tabs
           classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator, scroller: classes.tabsScroller}}
            value={value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="Articles" />
            <Tab label="Videos" />
            <Tab label="Comments" />
          </Tabs>
            {value === 0 && 
              <>
                <Typography component="div" style={{ padding: '24px 0px 0px 10px', fontSize: 16, fontWeight: 'bold' }}>
                  {`Total Count (${articlesCount})`}
               </Typography>
                <Articles 
                    isArticleTab={true} 
                    brandArticles={articles} 
                    btn={func} 
                    nextItemsMobile={itemsMobile} 
                    nextItemsDesktop={itemsDesktop} 
                    authorArticles={true}
                    mobileMaxNum={mobileMaxNum}
                />
              </>
            }
            {value === 1 && 
              <>
                <Typography component="div" style={{ padding: '24px 0px 10px 10px', fontSize: 16, fontWeight: 'bold' }}>
                    {`Total Count (${videosCount})`}
                </Typography>
                <BrandVideos 
                    videos={authorVideos} 
                    btn={videoNextFunc} 
                    videoItems={videoItems} 
                    videoNextBtn={videoNextFunc} 
                />
              </>
            }
            {
              value === 2 &&
              <div className="fbCommentWrapper" style={{ padding: '20px 14px' }}>
                <Comments href={`${process.env.BACKEND_URL}${asPath}`} />
              </div>
            }
      </div>
    );
  }
}

AuthorTabs.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AuthorTabs);
